// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';
import HighChartGraph, { ApiHandler as HC, HighChartOptions } from 'wdna-highchart';

import { emptyData } from 'wdna-components/lib/helpers/highchart';

import pressets from './pressets';

interface Props {
  graphType: string;
  title: string;
  data: any[];
  max: number;
  min: number;
  height?: string;
}

type State = unknown;

export default class ChartSimple extends React.Component<Props, State> {
  public static defaultProps: Partial<Props> = {
    height: 'calc(20vh)'
  };

  public constructor(props: Props) {
    super(props);
    this.state = {
    };
  }

  public getOptions = (): any => {
    const { title, min, max, graphType } = this.props;
    const options: HighChartOptions = _.cloneDeep(pressets[graphType]);

    const hc: HC = new HC(options);
    hc.setOption('title.text', `<b>${title}</b>`);
    hc.setOption('yAxis.min', min);
    hc.setOption('yAxis.max', max);

    return options;
  };

  public render(): JSX.Element {
    const { height } = this.props;
    const options: any = this.getOptions();
    const { data } = this.props;

    const style: React.CSSProperties = { height, minHeight: '100px', maxHeight: '340px', marginTop: '10px' };
    return (
      <div style={style}>
        <HighChartGraph data={data || emptyData} options={options} settings />
      </div>
    );
  }
}
